// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YIUIz","fullView":"styles_fullView__6cAmo"};